// Angular
import { NgModule } from "@angular/core";

// Afidium
import { CommonModule } from "@angular/common";
import { BtnModule } from "libraries/ui_button/btn.module";
import { AllSegmentDialogComponent } from "./all-segment-dialog.component";
import { SegmentListModule } from "../segment-list/segment-list.module";
import { NotificationModule } from "libraries/component/notification/notification.module";
import { CardModule } from "libraries/ui_card/card.module";
import { PipesModule } from "libraries/pipes/pipes.module";
import { SimpleSorterModule } from "libraries/pipes/simple-sorter/simple-sorter.module";

@NgModule({
    imports: [
        BtnModule,
        CommonModule,
        SegmentListModule,
        NotificationModule,
        CardModule,
        PipesModule,
        SimpleSorterModule,
    ],
    declarations: [
        AllSegmentDialogComponent,
    ],
    exports: [
        AllSegmentDialogComponent,
    ],
    entryComponents: [
        AllSegmentDialogComponent,
    ]
})
export class AllSegmentDialogModule {}
